import { gql } from '@apollo/client'

export const FIND_ALL_SUBSCRIPTION_CANCELLATION_REASONS = gql`
  query findAllSubscriptionCancellationReasons($platformId: String!, $startDate: DateTime, $endDate: DateTime) {
    findAllSubscriptionCancellationReasons(platformId: $platformId, startDate: $startDate, endDate: $endDate) {
      reason
      count
    }
  }
`

export const FIND_CANCELLATION_USERS = gql`
  query findCancellationUsers($input: CancellationUsersInput!, $includeCancellationComment: Boolean!) {
    findCancellationUsers(input: $input) {
      count
      items {
        id
        firstName
        lastName
        email
        membershipType @skip(if: $includeCancellationComment)
        duration @skip(if: $includeCancellationComment)
        cancellationReason @skip(if: $includeCancellationComment)
        cancellationReasonDescription @skip(if: $includeCancellationComment)
        cancellationComment @include(if: $includeCancellationComment)
      }
    }
  }
`
